import React, { useState, useEffect } from "react";
import fetchApi from "../../fetchApi";
import Application from "./Application";
import { mdiArrowRight } from "@mdi/js";
import Icon from "@mdi/react";
import Text from "../../components/typography/Text";

const ITEMS_COUNT = 3;

const Candidates = props => {
  const { mission, projectSlug, showAllApplications = false } = props;
  const [applications, setApplications] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    fetchApi(
      `/application?_embed&orderby=date&order=asc&per_page=${
        showAllApplications ? 100 : ITEMS_COUNT
      }&mission=${mission.id}`,
      {},
      true,
      ["X-WP-Total"]
    )
      .then(({ data, headers }) => {
        setApplications(data);
        const fetchedTotalCount = headers?.[0] ? parseInt(headers[0]) : 0;
        setTotalCount(fetchedTotalCount);
        props.setTotalCount?.(fetchedTotalCount);
      })
      .catch(error =>
        console.error("Can't fetch applications for mission", error)
      );
  }, []);

  if (!totalCount)
    return (
      <div className="oCandidates">
        <h4>Candidates</h4>
        <Text small>No application yet</Text>
      </div>
    );

  return (
    <div className="oCandidates">
      <h4>Candidates</h4>
      <div className="oCandidates_list">
        {applications?.map(application => (
          <Application key={application.id} application={application} />
        ))}
      </div>
      {!showAllApplications && (
        <a
          href={`/project/${projectSlug}/mission/${mission.id}`}
          className="oCandidates_seeAll"
        >
          See all {totalCount} candidates{" "}
          <Icon path={mdiArrowRight} size="14px" />
        </a>
      )}
    </div>
  );
};

export default Candidates;
